/**
 * @fileoverview Edit User locked placement.
 * @description The role and reporting manager shown read-only, for a user whose placement can't be
 * changed (anyone not ACTIVE), with the reason.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 * @author Anshul Rokde
 */

import { useTranslation } from 'react-i18next'

import DetailField from '@/shared/components/molecules/DetailField'

import type { UserDetail } from '@/features/users/types/users.types'

/**
 * @component
 * @param {{ user: UserDetail }} props - The user being edited.
 * @param {UserDetail} props.user - The user being edited.
 */
function EditUserLockedPlacement({ user }: { user: UserDetail }) {
  const { t } = useTranslation()

  return (
    <>
      <DetailField
        label={t('sales.userManagement.editUserForm.fields.role')}
        data-testid="edit-user-role-readonly"
      >
        {user.primaryRole?.name ?? '—'}
      </DetailField>
      <DetailField
        label={t('sales.userManagement.editUserForm.fields.reportsTo')}
        data-testid="edit-user-reporting-manager-readonly"
      >
        {user.reportingManager?.displayName ?? '—'}
      </DetailField>
      <p
        className="col-span-full text-[12px] text-slate"
        data-testid="edit-user-role-locked-message"
      >
        {t('sales.userManagement.editUserForm.roleLocked')}
      </p>
    </>
  )
}

export default EditUserLockedPlacement
